export const FETCH_RESTRICTIONS_CONFIG = "SEARCHSETTING/FETCH_RESTRICTIONS_CONFIG";
export const SAVE_RESTRICTIONS_CONFIG = "SEARCHSETTING/SAVE_RESTRICTIONS_CONFIG";
export const GET_WHATSAPP_LEADS = "LEADS/GET_WHATSAPP_LEADS";
